jQuery(document).ready(function () {

	svg4everybody();

	// fix for zurb-foundation-5 jquery incompatibility https://stackoverflow.com/questions/38400081/zurb-foundation-5-and-jquery-3-incompatible
	jQuery.fn.load = function (callback) { $(window).on("load", callback) };

	jQuery(document).foundation({
		accordion: {
			// allow multiple accordion panels to be active at the same time
			multi_expand: true,
			// allow accordion panels to be closed by clicking on their headers
			toggleable: true
		}
	});

	/**

		SLIDE NAVIGATION FUNCTIONS
		- Mobile main navigation
		- Content/Section navigation

	*/
	var mobileNavSlideSpeed = 500; // ms
	// mobile navigation toggle (hamburger)
	jQuery(".mobile-nav-toggle").click(function (e) {
		e.preventDefault();
		jQuery('#main-navbar #main-navigation').slideToggle(mobileNavSlideSpeed);
		jQuery('#main-navbar').toggleClass('mobile-active');
	});

	// mobile navigation expand
	jQuery(".expandable > a > i").click(function (e) {
		// see if there are child nav items for this item
		var children = jQuery(this).parent().parent('li').find('> .mega-menu, > .children');

		// if the item has child items, reveal them (toggle expanded class), otherwise, treat as a normal link
		if (children.length > 0) {
			e.preventDefault();
			children.slideToggle(mobileNavSlideSpeed);
			jQuery(this).parent().parent('li').toggleClass('expanded');
		}

		// this is a normal link, nothing to see here, proceed;
	});

	jQuery(".expandable .expand-icon i").unbind('click');
	jQuery(".expandable .expand-icon").click(function (e) {
		// see if there are child nav items for this item
		var children = jQuery(this).parent('li').find('> .mega-menu, > .children');

		// if the item has child items, reveal them (toggle expanded class), otherwise, treat as a normal link
		if (children.length > 0) {
			e.preventDefault();
			children.slideToggle(500);

			var parentLi = jQuery(this).parent('li');
			parentLi.toggleClass('expanded');

			if (parentLi.hasClass('expanded')) {
				parentLi.attr('aria-expanded', 'true');
				jQuery(this).next('ul').attr('aria-expanded', 'true');
			} else {
				parentLi.attr('aria-expanded', 'false');
				jQuery(this).next('ul').attr('aria-expanded', 'false');
			}
		}

		// this is a normal link, nothing to see here, proceed;
	});

	jQuery("#main-navigation .expandable").on("mouseover", function (element) {
		//jQuery(this).attr('aria-expanded', 'true');
	});

	jQuery("#main-navigation .expandable").on("mouseout", function (element) {
		//jQuery(this).attr('aria-expanded', 'false');
	});

	//function for retrieving querystring parameters
	jQuery.urlParam = function (name) {
		var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
		if (results == null) {
			return null;
		}
		else {
			return results[1] || 0;
		}
	}

	//remove any expanded menus when resizing upward past a threshold
	jQuery(window).resize(function () {
		if (jQuery(window).width() / parseFloat(jQuery("body").css("font-size")) >= 39) {
			jQuery(".expandable").removeClass("expanded active").find(".children").hide();
		}
	});

	// hide header search on pages with a banner search, otherwise attach overlay functionality
	if (jQuery('.banner .search-form').length > 0) {
		jQuery('header .icon.search').hide();
		jQuery("#main-navigation").addClass("no-header-search");
	}
	else {
		jQuery('header .icon.search').click(function () {
			if (jQuery(this).hasClass('active')) {
				if (jQuery('.search-bar-overlay input').val()) {
					window.location.href = '/Search?searchStudioQuery=*' + encodeURIComponent(jQuery('.search-bar-overlay input').val()) + '*';
				} else {

				}
			} else {
				jQuery(this).addClass('active');
				jQuery('.page-wrap > header').addClass('searchOpen');
				jQuery('<div class="search-bar-overlay search-form"></div>').append('<input type="search" class="top-search-input" data-search />').append('<a href="#" class="clearInput"><span></span><span></span></a>').append('<a href="#" class="quitSearch" aria-label="Close search">x</a>').appendTo('.page-wrap');

				jQuery('.search-bar-overlay').append($predictiveSearchStructure);
				// search predictive search
				//jQuery(".search-bar-overlay input[type='search']").keyup(predictiveSearch);
				//jQuery(".search-bar-overlay input[type='search']").focusin(predictiveSearch);
				jQuery(".search-bar-overlay input[type='search']").keyup(debouncePredictiveSearch);
				jQuery(".search-bar-overlay input[type='search']").focusin(debouncePredictiveSearch);
				jQuery('.search-bar-overlay').addClass('initial');
				setTimeout(function () {
					jQuery('.search-bar-overlay input').addClass('active').attr('aria-hidden', 'false').focus();
					jQuery('.search-bar-overlay input').on('keydown keyup focusin focusout', function () {
						if (jQuery(this).val()) {
							jQuery('.clearInput').addClass('active');
						} else {
							jQuery('.clearInput').removeClass('active');
						}
					});
					jQuery('.search-bar-overlay input').keypress(function (event) {

						var keycode = (event.keyCode ? event.keyCode : event.which);
						if (keycode == '13') {
							event.preventDefault();
							if (jQuery(this).val()) {
								window.location.href = '/Search?searchStudioQuery=*' + encodeURIComponent(jQuery(this).val()) + '*';
							}
						}
					});
					jQuery('.clearInput').click(function (event) {
						event.preventDefault();
						jQuery('.search-bar-overlay input').val('').focus();
						jQuery(this).removeClass('active');
					});
					jQuery('.quitSearch').click(function (event) {
						event.preventDefault();
						jQuery('.search-bar-overlay').remove();
						jQuery('header .icon.search').removeClass('active');
					});
				}, 10);
			}

		});
	}

	// If a page-heading is longer then 146 char, give it long-heading class
	if (jQuery.trim(jQuery('.page-header .heading').text().length) > 146) {
		jQuery('.page-header .heading').addClass('long-heading');
	}

	// On video-btn click, toggle video element siblings (play/pause)
	jQuery('.video-btn').click(function (event) {
		event.preventDefault();
		if (jQuery(this).hasClass('active')) {
			jQuery(this).removeClass('active');
			jQuery(this).siblings('video').get(0).play();
		} else {
			jQuery(this).addClass('active');
			jQuery(this).siblings('video').get(0).pause();
		}
	});




	// If there is a sitecore form on the page, initiate form JS
	var timeout;
	if (jQuery('.scfForm')) {
		// Populate locations from CRM for international enquire/apply forms

		if (jQuery('input[data-sc-field-name="Country of origin"]').length > 0) {
			var countriesURL = "/StatusService.svc/StatusService/GetCountries";

			var result = jQuery.ajax({
				url: countriesURL,
				dataType: "json",
				success: function (data) {
					var countriesObject = JSON.parse(data.GetCountriesResult);
					if (countriesObject.length == 0) {
						// handle no response

					} else {
						// sort the country array alphabetically
						countriesObject.sort(function (a, b) {

							return a.CountryName.localeCompare(b.CountryName);

						});

						jQuery('input[data-sc-field-name="Country of origin"]').closest('div.scfSingleLineTextBorder').hide().after('<div class="scfDropListBorder"><label for="countryChooser" class="scfDropListLabel">Country of origin <span class="scfRequired">*</span></label><div class="scfDropListGeneralPanel"><select id="countryChooser" name="countryChooser"><option value="" selected="selected"></option></select></div></div>');
						var countryCount, numCountries;
						for (countryCount = 0, numCountries = countriesObject.length; countryCount < numCountries; countryCount++) {
							jQuery('#countryChooser').append('<option value="' + countriesObject[countryCount].CountryId + '">' + countriesObject[countryCount].CountryName + '</option>');
						}
						jQuery('#countryChooser').change(function () {
							jQuery('input[data-sc-field-name="Country of origin"]').val(jQuery('#countryChooser').val());
						});
						// jQuery('#countryChooser').addClass('active').parent().siblings('label').addClass('active');
					}
				}
			});



		}

		// if we're on a career-level enquiry page, populate the hidden career field from the querystring
		if (jQuery.urlParam('cfid') != null && jQuery.urlParam('cfid') != "") {
			careerfieldname = decodeURIComponent(jQuery.urlParam('cfid'));
			if (jQuery('input[data-sc-field-name=CareerField]').length > 0) {
				if (jQuery('input[data-sc-field-name=CareerField]').attr('value') == undefined) {
					jQuery('input[data-sc-field-name=CareerField]').attr('value', careerfieldname);
				}
			}
		}


		// if input has a value, then add active class for styling
		function inputValCheck() {
			clearTimeout(timeout);
			jQuery('.scfForm input').each(function () {
				if (jQuery(this).val()) {
					jQuery(this).parent().siblings('label').addClass('active');
				}
			});
			timeout = setTimeout(function () {
				inputValCheck();
			}, 250);
		}
		jQuery('.scfForm input').each(function () {
			if (jQuery(this).val()) {
				jQuery(this).parent().siblings('label').addClass('active');
			}
		});

		jQuery('.scfForm textarea').each(function () {
			if (jQuery(this).val()) {
				jQuery(this).parent().siblings('label').addClass('active');
			}
		});
		clearTimeout(timeout);
		timeout = setTimeout(function () { inputValCheck() }, 250);
	}
	// check selects on pageLoad for a value (browser refresh, mostly after a wrong submit of form
	jQuery('.scfForm select').each(function () {
		if (jQuery(this).find(":selected").text() == "") {
			jQuery(this).parent().siblings('label').removeClass('active');
		} else {
			jQuery(this).parent().siblings('label').addClass('active');
		}
	});
	// When you change the select value, or focus on it, active visual.
	jQuery('.scfForm').on('focus change', 'select', function () {
		if (jQuery(this).find(":selected").text() == "") {
			jQuery(this).parent().siblings('label').removeClass('active');
		} else {
			jQuery(this).parent().siblings('label').addClass('active');
		}
	});

	// check input values for values
	jQuery('.scfForm input, .scfForm textarea').focusin(function () {
		jQuery(this).parent().siblings('label').addClass('active');
	});

	jQuery('.scfForm input, .scfForm textarea').focusout(function () {
		if (jQuery(this).val()) {

		} else {
			jQuery(this).parent().siblings('label').removeClass('active');
		}

	});

	jQuery('.scfForm .scfRequired').each(function () {
		jQuery(this).appendTo(jQuery(this).parent().find('label'));
	});

	jQuery('.scfForm .scfValidatorRequired').each(function () {
		jQuery(this).parent().find('input,textarea,select').css('border-color', 'red');
		jQuery(this).appendTo(jQuery(this).parent().find('label'));

	});


	jQuery('section.sidebar .scfForm label').each(function () {
		if (jQuery(this).text().trim().slice(-1) != "*") {
			jQuery(this).text(jQuery(this).text() + ' (optional)');
		}
	});

	// If "Register my interest" button exists, remove any enquiry form and Apply Now
	if (jQuery('.enquire-apply-link').length > 0) {
		jQuery('.page-options').next('.webform').remove();
		jQuery('.course-options').find('[id$="liApply"]').remove();
	}

	// Add extra class for radio and checkbox labels
	jQuery('.scfForm input[type=radio]').siblings('label').addClass('radio-label');
	jQuery('.scfForm input[type=checkbox]').siblings('label').addClass('checkbox-label');

	// Move main page form into holder if provided
	if (jQuery('.main-content-wrapper .formholder').length > 0) {
		jQuery('.main-content-wrapper div.webform').appendTo('.formholder');
	}
    
    // Add Turnstile validation widget
    // Temporary: target career field form by id
    jQuery("form[data-sc-fxb='69eff294-9564-4237-9cb5-a05b1bc0a47c'] .scfForm .scfSubmitButtonBorder").before('<div class="cf-turnstile" data-sitekey="0x4AAAAAAEqr0yF580gzhbIQ"></div>');
    
    if (jQuery(".cf-turnstile").length > 0) {
        const turnstileWidgetId = turnstile.render(".cf-turnstile", {
            sitekey: "0x4AAAAAAEqr0yF580gzhbIQ",
            callback: function (token) {
                console.log("Success:", token);
            },
        });
    }
    
	// Application status
	jQuery('section.status-query .scfForm').on('click', 'button', function (event) {
		event.preventDefault();

		jQuery('.fielderror').remove();
		var valid = true;

		/*var referencenumber = jQuery("input[name=refid]").val();
		referencenumber = referencenumber.replace(/\D+/g, '');
		jQuery("#myPhone").val(referencenumber);
		if (referencenumber.length != 10) {
			jQuery("#myPhone").after('<span class="fielderror">Your application reference ID should be 10 numeric digits</span');
			valid = false;
		}*/
		if (jQuery('input[name=refid]').val() == "") {
			jQuery('input[name=refid]').after('<span class="fielderror">Your application reference ID is required</span');
			valid = false;
		}

		if (jQuery('input[name=lastname]').val() == "") {
			jQuery('input[name=lastname]').after('<span class="fielderror">Your last name is required</span');
			valid = false;
		}

		var postcode = jQuery("input[name=postcode]").val();
		postcode = postcode.replace(/\D+/g, '');
		jQuery("input[name=postcode]").val(postcode);
		if (postcode.length != 4) {
			jQuery("input[name=postcode]").after('<span class="fielderror">Postcode is required and should be 4 numeric digits</span');
			valid = false;
		}

		if (valid) {

			if (jQuery("section.status-query.self-booking").length > 0) {
				var bookingURL = "/StatusService.svc/StatusService/GetAppointments/" + jQuery('input[name=refid]').val() + "/" + jQuery('input[name=lastname]').val() + "/" + jQuery('input[name=postcode]').val();
				var result = jQuery.ajax({
					url: bookingURL,
					dataType: "json",
					success: function (data) {
						var detailsMatched = JSON.parse(data.GetAppointmentsResult);
						if (detailsMatched.verified) {
							var appointmentsArray = detailsMatched.eventAppointmentResponses;
							if (appointmentsArray.length == 0) {
								jQuery('.status-section').hide();
								jQuery('.appointments-noresult').show();
							} else {
								if (detailsMatched.participants.length !== 0) {
									sampleData = appointmentsArray.filter(function (id) {
										return id.EventId != detailsMatched.participants[0].EventId;
									});
									appointments = appointmentsArray.filter(function (id) {
										return id.EventId != detailsMatched.participants[0].EventId;
									});

								} else {
									sampleData = appointmentsArray;
									appointments = appointmentsArray;
								}
								bookingApp.referenceid = jQuery('input[name=refid]').val();
								bookingApp.courseName = detailsMatched.CourseName;
								bookingApp.territoryName = detailsMatched.Territory;
								bookingApp.phoneNumber = detailsMatched.PhoneNumber;
								if (detailsMatched.participants.length > 0) {
									bookingApp.participantid = detailsMatched.participants[0].ParticipantId;
									bookingApp.currentAppointment = detailsMatched.participants[0];
								} else {
									bookingApp.participantid = 0;
								}
								if (detailsMatched.CountOfCancelledAppointments != null) {
									bookingApp.cancelcount = detailsMatched.CountOfCancelledAppointments;
								}
								if (detailsMatched.CountOfReschduledAppointments != null) {
									bookingApp.reschedulecount = detailsMatched.CountOfReschduledAppointments;
								}
								bookingApp.init();
								calendarApp.init();
								jQuery('.status-section').hide();
								jQuery('.status-query').hide();

							}
						} else {
							jQuery('.status-section').hide();
							jQuery('.status-noresult').show();
						}
					}
				});
			} else {
				var statusURL = "/StatusService.svc/StatusService/GetStatus/" + jQuery('input[name=refid]').val() + "/" + jQuery('input[name=lastname]').val() + "/" + jQuery('input[name=postcode]').val();

				var result = jQuery.ajax({
					url: statusURL,
					dataType: "json",
					success: function (data) {
						var statusObject = JSON.parse(data.GetStatusResult);
						if (statusObject.ApplicationStatus == null) {
							jQuery('.status-section').hide();
							jQuery('.status-noresult').show();
						} else {

							if (statusObject.WebsiteStatus != null) {
								jQuery('.status-section').hide();
								jQuery('.status-result').show(); var stepNumber = parseInt(statusObject.WebsiteStatus.substring(5, 6));
								// highlight the step in the tree and the accordion
								jQuery('.status-result .status__item').removeClass('status--current');
								jQuery('.status-result .status__item').eq(stepNumber - 1).addClass('status--current');
								jQuery('.status-result li.accordion-navigation').eq(stepNumber - 1).find('a').trigger('click');
							} else {
								//special cases for application status with no assigned process step
								var applicationStatus = "unknown";
								var statusList = [["complete", "ENROLLED & PAID - CLS USE ONLY"],
								["closed", "Application Cancelled", "Cancelled - Competitor", "Cancelled-Delivery Mode/Campus", "Cancelled - Declined by Dept", "Cancelled - Nurture No contact", "Cancelled - Ineligible", "Cancelled - Course Offer NA", "Cancelled - Other", "Cancelled - Price", "Cancelled - Personal Reasons", "Cancelled - Spam", "Cancelled - Course suitability", "Cancelled - PTR unsuitable LLN", "Duplicate Application - Ignore", "Invalid Application - Ignore"],
								["delayed", "Term 1 (JAN)", "Term 2 (APR)", "Term 3 (JULY)", "Term 4 (OCT)"]];
								var listLength = statusList.length;
								var listCount = 0;
								for (; listCount < listLength; listCount++) {
									if (statusList[listCount].indexOf(statusObject.ApplicationStatus) > -1) {
										applicationStatus = statusList[listCount][0];
									}
								}
								jQuery('.status-section').hide();
								jQuery('.status-other').show();
								jQuery('.status-other div#application-' + applicationStatus).show();

							}
							//update application fields in the copy
							jQuery('span.application-name').html(statusObject.FullName);
							jQuery('span.course-name').html(statusObject.CourseApplied);
							jQuery('span.application-number').html(statusObject.ApplicationId);
							jQuery('span.reference-id').html(statusObject.StrataReferenceId);
							jQuery('span.application-status').html(statusObject.ApplicationStatus);

							//remove enquiry fields for privacy
							jQuery('.status-query').remove();
						}
					}
				});
			}
		}
	});

	// Thank you popup
	jQuery('.scfForm').on('click', 'div.thankyou-popup', function () {
		jQuery('div.thankyou-popup').hide();
		thankyouRefresh();
	});

	jQuery('body.thankyou-popup').on('click', function () {
		jQuery('div.thankyou-popup', window.parent.document).hide();
		thankyouRefresh();
	});

	function thankyouRefresh() {
		//refresh parent window when popup is closed - reduces resubmissions
		var href = window.parent.location.href;
		if (href.indexOf('#') !== -1) {
			href = href.substring(0, href.indexOf('#'));
		}
		setTimeout(function () { window.parent.location.href = href; }, 1);
	}
	/*function ChangeUrl(page, url) {
		if (typeof (history.pushState) != "undefined") {
			var obj = { Page: page, Url: url };
			history.pushState(obj, obj.Page, obj.Url);
		} else {
			alert("Browser does not support HTML5.");
		}
	} 
	ChangeUrl("Test","online")*/
	var href = window.location.href;
	if (href.indexOf('#popup-') !== -1) {

		var iframeName = href.substring(href.indexOf('#popup-') + 7);
		   jQuery('iframe').attr("src", iframeName);
		if (typeof (history.pushState) != "undefined") {
			var obj = { Page: page.title, Url: href.substring(0, href.indexOf('#')) };
			history.pushState(obj, obj.Page, obj.Url);
		}
	}

	// Pop-up help icons
	jQuery('.helplink').click(function (event) {
		var linkid = jQuery(this).attr("id");
		jQuery("#" + linkid.substring(0, linkid.length - 8) + "helptext").addClass("active");
		event.stopPropagation();
	});
	jQuery('.helplink').mouseenter(function () {
		var linkid = jQuery(this).attr("id");
		jQuery("#" + linkid.substring(0, linkid.length - 8) + "helptext").show();
	}).mouseleave(function () {
		var linkid = jQuery(this).attr("id");
		jQuery(".helptext").each(function () {
			if (!jQuery(this).hasClass("active")) {
				jQuery(this).hide();
			}
		});
	});
	jQuery("body").on("click", function () {
		jQuery(".helptext").each(function () {
			jQuery(this).hide();
			jQuery(this).removeClass("active");
		});
	});

	function addSpans(headingElement) {
		var headingwords = headingElement.text().trim().split(" ").filter(function (el) { return el != ""; });

		headingElement.empty();
		jQuery.each(headingwords, function (i, v) {
			// wrap each word in span tags
			headingElement.append(jQuery("<span>").text(v));

			// break before last word (main header only)
			/*if ( headingElement.is('h1')) {
				if (i == headingwords.length - 2) {
					headingElement.append("<br />");
				}
			}*/

		});
	}

	// Campaign banner
	/*function addSpans(headingElement) {
		if (headingElement.closest('body.home').length == 1) {
			var headingwords = headingElement.text().trim().split(" ");
			headingElement.empty();
			jQuery.each(headingwords, function(i, v) {
				// wrap each word in span tags
				headingElement.append(jQuery("<span>").text(v));

				// break before last word (main header only)
				if ( headingElement.is('h1')) {
					if (i == headingwords.length - 2) {
						headingElement.append("<br />");
					}
				}
			});
		} else {
			jQuery("<br />").insertBefore(headingElement.find("span.subtitle"));
		}
	}*/
	if (jQuery('.campaign-profile').length > 0) {
		addSpans(jQuery('.campaign-profile h1'));

		if (jQuery('.campaign-profile .subtitle').length > 0) {
			var subtitles = jQuery('.campaign-profile .subtitle').html().split("|");
			jQuery('.campaign-profile .subtitle').html(subtitles[0]);
			addSpans(jQuery('.campaign-profile .subtitle'));
			if (subtitles.length > 1) {
				jQuery('<span class="subtitle2">' + subtitles[1] + '</span>').insertAfter('.campaign-profile .subtitle');
				addSpans(jQuery('.campaign-profile .subtitle2'));
			}
		}
	}

	// CTA FORM - if there are errors, remove height restriction on block
	if (jQuery(".cta-form .scfValidationSummary").length > 0) {
		jQuery(".cta-form .scfValidationSummary").each(function () {
			if (jQuery(this).is(":visible")) {
				jQuery(this).closest(".cta-form").first().css("height", "auto");
			}
		});
	}

	jQuery("header .search a").click(function (e) {
		e.preventDefault();
		var bannerSearch = jQuery(".banner .search-form");
		if (bannerSearch.length > 0) {
			//alert("there is a banner search field");
		}

		jQuery(this).toggleClass("active");

		jQuery(".banner").toggleClass("header-search-active");
	});





	var courseSearchPage = 0;
	var articleSearchPage = 0;
	// search pagination
	jQuery(".load-more a").click(function (e) {
		e.preventDefault();
		var coursesServiceURL = "/api/chisholmsearch/GetCourseResult/";
		var articlesServiceURL = "/api/chisholmsearch/GetArticleResult/";

		var searchString = ""; // instantiate search string variable (should be null if not testing)

		var serviceURL = null;
		var searchPage = 0;

		var getCourses = false;
		var getArticles = false;


		// if this is the course list button
		if (jQuery(this).parent().hasClass("courses")) {
			serviceURL = coursesServiceURL;
			getCourses = true;

			// check if there is a starting page number, if it's already loaded in js use that, otherwise get it from the hidden field
			if (courseSearchPage > 0) {
				courseSearchPage++;
				searchPage = courseSearchPage;
			}
			else if (jQuery(".pagenumbercourse").val() > 0) {
				courseSearchPage = jQuery(".pagenumbercourse").val();
				courseSearchPage++;
				searchPage = courseSearchPage;
			}
			else {
				courseSearchPage++;
				searchPage = courseSearchPage;
			}
		} // otherwise it's the articles button, in theory
		else {
			serviceURL = articlesServiceURL;
			getArticles = true;
			// check if there is a starting page number
			if (jQuery(".pagenumberarticle").val() != null && jQuery(".pagenumberarticle").val() > 0) {
				searchPage = jQuery(".pagenumberarticle").val();
			}
			// check if there is a starting page number, if it's already loaded in js use that, otherwise get it from the hidden field
			if (articleSearchPage > 0) {
				articleSearchPage++;
				searchPage = articleSearchPage;
			}
			else if (jQuery(".pagenumberarticle").val() > 0) {
				articleSearchPage = jQuery(".pagenumberarticle").val();
				articleSearchPage++;
				searchPage = articleSearchPage;
			}
			else {
				articleSearchPage++;
				searchPage = articleSearchPage;
			}
		}

		// get the search keyword query string
		if (jQuery.urlParam('keyword') != null && jQuery.urlParam('keyword') != "") {
			searchString = decodeURIComponent(jQuery.urlParam('keyword')); // query string value
		}

		var result = jQuery.ajax({
			url: serviceURL + searchString + "/" + searchPage,
			dataType: "json",
			success: function (data) {

				if (getCourses) {
					displayCourseResults(data);
					// if we are at the end of the results, hide button
					if (data.TotalResult < (data.PageSize * (courseSearchPage + 1))) {
						jQuery(".load-more.courses").html("<p>There are no more matching courses.</p>");
					}

					var FreeTafeNote = data.FreeTafeNote;
					var IsFreeTafeCourseExist = data.IsFreeTafeCourseExist;
					if (IsFreeTafeCourseExist !== undefined || IsFreeTafeCourseExist !== null || IsFreeTafeCourseExist.length > 0) {
						if (IsFreeTafeCourseExist === true && (FreeTafeNote !== undefined || FreeTafeNote !== null || FreeTafeNote.length > 0)) {
							if (jQuery('.alert.alert--inline.alert--desktop').length === 0) {
								jQuery(".load-more.courses").after("<div class='alert alert--inline alert--desktop'><img class='icon'  src='/img/Chisholm/fc-icon.svg' alt='Free TAFE Courses'><p>" + FreeTafeNote + "</p></div>");
								jQuery(".courses-list.clearfix").before("<div class='content row column alert alert--mobile'><p class='alert__content'><img src='/img/Chisholm/fc-icon.svg' class='icon'>" + FreeTafeNote + "</p></div>");
							}
						}
					}

					jQuery(".courses-list .new-page").last().find("a:first-child").focus();

					// UPDATE SHORTLIST CONTROLS
					// loop through list and update text and icon accordingly for shortlist
					jQuery('.shortlist').each(updateShortlistFn);

					//add click event to shortlist buttons
					//remove the click event and then add it back so that it does not get added multiple times
					jQuery("a.shortlist").off('click').click(shortlistClickFn);
				}
				else if (getArticles) {
					displayArticleResults(data);

					// if we are at the end of the results, hide button
					if (data.TotalResult < (data.PageSize * (articleSearchPage + 1))) {
						jQuery(".load-more.articles").html("<p>There are no more matching articles.</p>");
					}

					jQuery(".articles-list .new-page").last().find("a:first-child").focus();
				}

				return;
			},
			error: function (data) {
				console.log("no results returned.");
				return;
			}
		});

	});

	var displayCourseResults = function (data) {
		var courseContainer = jQuery(".courses-list ul");
		if (data.Courses != null && data.Courses !== undefined && data.Courses.length > 0) {
			displayCourses = [];
			for (i = 0; i < data.Courses.length; i++) {
				courseID = data.Courses[i].CourseItemID;
				courseID = courseID.replace("{", "").replace("}", "");

				var newPageClass = ""; // mark new pages for focus
				if (i == 0) {
					newPageClass = " class='new-page'";
				}
				var CourseStream = data.Courses[i].CourseStream;
				if (CourseStream !== undefined || CourseStream !== null || CourseStream.length > 0) {
					CourseStream = "<span class='clean'>" + CourseStream + "</span>";
				}
				var CourseFreeTafeEligible = data.Courses[i].CourseFreeTafeEligible;
				if (CourseFreeTafeEligible !== undefined || CourseFreeTafeEligible !== null || CourseFreeTafeEligible.length > 0) {
					if (CourseFreeTafeEligible === true) {
						CourseFreeTafeEligible = "<img style='width: 20px;height: 20px;vertical-align: text-bottom;' class='icon' src='/img/Chisholm/fc-icon.svg' alt='Free TAFE Courses'>";
					}
					else {
						CourseFreeTafeEligible = "";
					}
				}
				displayCourses.push("<li" + newPageClass + "><a href='" + data.Courses[i].CourseURL + "' title='Go to " + data.Courses[i].CourseTitle + "'>" + data.Courses[i].CourseTitle + CourseStream + CourseFreeTafeEligible + " <i class='icon-indicator'></i></a><a href='./' class='shortlist' data-guid='" + courseID + "' title='Add " + data.Courses[i].CourseTitle + " to your shortlist'>Shortlist <i class='icon-star'></i></a></li>");
			}
			courseContainer.append(displayCourses.join("\n"));

		}
		return;
	}

	var displayArticleResults = function (data) {
		var articleContainer = jQuery(".articles-list ul");
		if (data.Articles != null && data.Articles !== undefined && data.Articles.length > 0) {
			displayArticles = [];
			for (i = 0; i < data.Articles.length; i++) {
				var newPageClass = ""; // mark new pages for focus
				if (i == 0) {
					newPageClass = " class='new-page'";
				}
				displayArticles.push("<li" + newPageClass + "><a href='" + data.Articles[i].ArticleURL + "' title='Go to " + data.Articles[i].ArticleTitle + "'>" + data.Articles[i].ArticleTitle + "<p>" + data.Articles[i].ArticleSummary + "</p><span class='link'>Learn more <i class='icon-indicator'></i></span></a></li>");
			}
			articleContainer.append(displayArticles.join("\n"));
		}
		return;
	}


	/**
	 *  SET ANCHOR FOR CAREER PAGE
	 */

	// Get career field
	if (location.href.indexOf('#') > -1) {
		var careerfield = location.href.substr(location.href.indexOf('#') + 1);
		if (careerfield != null && careerfield != "") {
			// count the number for .accordion-navigation
			var numAccordions = jQuery('.accordion-navigation').length;

			if (numAccordions == 3) {
				jQuery("." + careerfield).next('.accordion-navigation:first').toggleClass("active").children().toggleClass("active");
			}
			else {
				jQuery("." + careerfield).parent('.accordion-navigation:first').toggleClass("active").children().toggleClass("active");
			}
		}
	}

	/* Workaround for online short courses - hide sessions, time columns */

	if (jQuery('.page-wrap').html().indexOf('Page Type: ChisholmOnline') > -1) {
		jQuery('#available-sessions table tr').find('th:eq(4),th:eq(5),td:eq(4),td:eq(5)').hide();
	}


});

/* Add custom birthdate validator to jquery validate */
if (typeof (jQuery.validator) != "undefined") {
	jQuery.validator.addMethod("birthdatevalidator", function (val, element) {
		// regex test - valid format
		var dateRegex = /^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/;
		if (dateRegex.test(val) == false) {
			return false;
		}
		// date parse - valid date
		var dateArray = val.split('/');
		var dateInMilliseconds = Date.parse(dateArray[2] + "-" + dateArray[1] + "-" + dateArray[0]);
		if (isNaN(dateInMilliseconds)) {
			return false;
		}
		// business rules check 
		var parsedDate = new Date(dateInMilliseconds);
		var currentYear = new Date().getFullYear();

		if ((parsedDate > new Date().setFullYear(currentYear - 2)) || (parsedDate < new Date().setFullYear(currentYear - 120))) {
			return false;
		}
		return true;

	});

	jQuery.validator.unobtrusive.adapters.addBool('birthdatevalidator');
	jQuery.validator.unobtrusive.parse();

}

/**
 *  Put users view on the subscribe form they just completed.
 *  This is in a setTimeout because the page bumps the user back up to the top
 *  of the page on load. We wait until this function has run then drop the users
 *  back down the page.
**/
var subscribeForm = jQuery("article[aria-label='subscribe'] .scfForm .success");

if (subscribeForm.length > 0) {
	setTimeout(function () {
		jQuery("html,body").animate({
			scrollTop: document.body.scrollHeight
		}, 1);
	}, 2000);
}

/**
  * Add Google Analyitcs behaviour to buttons because we can't add it to
  * the form manually.
**/
var analyticsForm = jQuery(".webform .scfForm .success");
if (analyticsForm.length >= 1) {
	var form = jQuery(".content .webform .scfForm").attr('id');
	switch (form) {
		case "form_4683A14222C9498A85FB341C9F6A975D": // Apply Now Form
			console.log("application complete push")
			dataLayer.push({ 'event': 'application-complete' });
			break;
		case "form_105894F304A645388874DC6E0B56C83E": // Enquiry Form
			console.log("enquiry complete push")
			dataLayer.push({ 'event': 'enquiry-complete' });
			break;
		case "form_65AC29D469914D8EA86EC85B5DEBB1FE": // Contact Form
			console.log("contact complete push")
			dataLayer.push({ 'event': 'contact-complete' });
			break;
		default:
			// Continue because there is nothing to log.
			console.log("No Analytics");
	}
}


function disableSubmitButton(groupValidator, submitButton) {
	// disable already handled by wffm
	// jQuery("#" + submitButton).closest("div").find("button[class^=scf]").prop("disabled", true);

	// for the enquire and apply form - set up some default fields to pass mandatory validation on enquiries
	if (jQuery('.form-apply').length > 0) {
		if (jQuery('.enquiry-type input[type="radio"]').filter(function () { return jQuery(this).prop('checked'); }).val() == "register") {
			if (jQuery('label:contains("Course")').closest("div").find("select").val() == null || jQuery('label:contains("Course")').closest("div").find("select").val() == "") {
				jQuery('label:contains("Course")').closest("div").find("select").append("<option>None selected</option>");
				jQuery('label:contains("Course")').closest("div").find("select").val("None selected");
			}
			if (jQuery('label:contains("Preferred"):contains("Location")').closest("div").find("select").val() == null || jQuery('label:contains("Preferred"):contains("Location")').closest("div").find("select").val() == "") {
				jQuery('label:contains("Preferred"):contains("Location")').closest("div").find("select").val("Dandenong");
			}
			if (jQuery('label:contains("Study"):contains("load")').closest("div").find("select").val() == null || jQuery('label:contains("Study"):contains("load")').closest("div").find("select").val() == "") {
				jQuery('label:contains("Study"):contains("load")').closest("div").find("select").val("Full Time");
			}
			if (jQuery('label:contains("Preferred Starting Year")').closest("div").find("select").val() == null || jQuery('label:contains("Preferred Starting Year")').closest("div").find("select").val() == "") {
				//select first valid option
				jQuery('label:contains("Preferred Starting Year")').closest("div").find("select").find('option:not(:empty)').first().prop('selected', true);
			}
		}
	}
	// close web chat survey
	if (typeof (chisholmChatPlugin) != "undefined") {
		chisholmChatPlugin.command('Toaster.close');
	}
}

if (typeof Genesys !== "undefined") {
    Genesys("subscribe", "MessagingService.messagesReceived", function(e) { 
        // OldTrombone - G2 (Trombone_Short_G2_v1_4.wav) by sgossner -- https://freesound.org/s/374936/ -- License: Creative Commons 0
        const soundsource = "data:audio/wav;base64,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";
        const sound = new Audio(); 
        sound.src = soundsource;
        if (e.data) {        
            const respDataObject = e.data || {};
            if (respDataObject.messages[0].direction == "Outbound") {
                sound.play();
            }
        }
    });
}